import React from 'react';
import { ReportProblemOutlined } from '@material-ui/icons';

export const NoLicenseWarn = () => {
  return (
    <div className="m-user-edit-drawer-section__no-licenses-warn">
      <div className="m-user-edit-drawer-section__no-licenses-warn__icon">
        <ReportProblemOutlined />
      </div>
      <div>
        <span className="m-user-edit-drawer-section__no-licenses-warn__bold">
          Warning!{' '}
        </span>
        Once saved, this user will no longer be licensed to use any products on
        the NextOS platform.
      </div>
    </div>
  );
};
